module.exports = __webpack_public_path__ + "img/cards_image_mastercard.b6c9636.svg";